// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HealthCard_wrapper__31rGU"};